<template>
  <div class="vld-parent" ref="cursos_list">
    <div v-if="empty" class="row">
      <div class="col-12 mb-3 text-center">
        <badge type="info" class="bg-white">
          Não existem cursos cadastrados na trilha de capacitação até o momento
        </badge>
      </div>
    </div>
    <div class="row text-center mt-1 mb-5">
      <div class="col-12">
        <base-button
          :custom="true"
          size="sm"
          type="primary"
          @click="$router.push('/admin/trilha/cursos/novo')"
          ><i class="fas fa-plus mr-1"></i> Cadastrar curso</base-button
        >
      </div>
    </div>
    <div v-if="!empty">
      <div class="row">
        <div class="col-12">
          <div class="card-deck">
            <div
              class="col-lg-4 col-md-6 mb-5 d-flex align-items-stretch"
              v-for="curso in cursos"
              :key="curso.user_id"
            >
              <div class="card flex-grow-1 border-0">
                <div class="card-image">
                  <img
                    class="card-img-top rounded-top"
                    :src="curso.image_url || placeholderImg"
                    alt="Imagem curso"
                  />
                  <div class="image-overlay"></div>
                </div>

                <div class="card-body py-3">
                  <h2 class="card-title mb-1">{{ curso.title }}</h2>
                  <p class="description mb-0">{{ curso.subtitle }}</p>
                  <p class="card-text mt-2 mb-0" v-if="curso.description">
                    <span :title="curso.description">{{
                      truncate(curso.description)
                    }}</span>
                  </p>
                  <p v-if="!curso.is_active" class="mt-2 mb-0">
                    <badge type="warning" v-tooltip="'O curso está oculto'"
                      >Oculto</badge
                    >
                  </p>
                </div>
                <div class="card-footer text-center">
                  <router-link
                    :to="'/admin/trilha/cursos/' + curso.id + '/editar'"
                    class="btn btn-white py-1 px-2"
                    v-tooltip="'Editar curso'"
                    ><i class="fas fa-edit text-info"></i
                  ></router-link>
                  <router-link
                    :to="'/admin/trilha/cursos/' + curso.id + '/materiais'"
                    class="btn btn-white py-1 px-2"
                    v-tooltip="'Gerenciar materiais do curso'"
                    ><i class="fas fa-book text-dark-green"></i
                  ></router-link>
                  <router-link
                    :to="'/admin/trilha/cursos/' + curso.id + '/ranking'"
                    class="btn btn-white py-1 px-2"
                    v-tooltip="'Ver ranking de visualização'"
                    ><i class="fas fa-award text-yellow"></i
                  ></router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-muted text-right mt-3">
          <b>{{ cursos.length }}</b> cursos de capacitação cadastrados ao total
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "cursos_list",
  data() {
    return {
      cursos: [],
      empty: false,
      placeholderImg: "/img/pages/default_banner_course.jpg",
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.cursos_list,
      width: 150,
      height: 150,
      opacity: 0,
    });
    try {
      const { data } = await api.get(`/admin/courses`);
      if (data.length) this.cursos = data;
      else this.empty = true;
      loader.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar os módulos da trilha");
    }
  },
  methods: {
    truncate(text, stop = 150, clamp = "...") {
      if (!text) return "N/A";
      return text.slice(0, stop) + (stop < text.length ? clamp : "");
    },
  },
};
</script>
<style scoped>
.card-img-top {
  height: 200px;
  margin: auto;
  object-fit: cover;
}

.card-image {
  position: relative;
  height: 200px;
}

.image-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0.2;
  transition: 0.5s ease;
  background: rgba(0, 0, 0, 0.5);
}

.card:hover .image-overlay {
  opacity: 1;
}
</style>
